import { useMsal } from "@azure/msal-react";

export const UserButton = () => {
    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();
    const handleLogOutPopup = () => {
        instance
            .logoutPopup({
                mainWindowRedirectUri: "/", // redirects the top level app after logout
                account: instance.getActiveAccount(),
                logoutHint: instance.getActiveAccount()?.username // skips the account picker
            })
            .catch(error => console.log(error));
    };
    const userText = `${activeAccount?.name}`;

    return (
        <div className="flyout-container inline-block relative">
            <div className="flyout-menu hidden absolute bottom-full left-[-.5rem] z-[100] md:w-[228px] w-[288px] transition-all ease-linear duration-300 bg-eq-white shadow-sm-up rounded-[5px]">
                <div className="py-2 px-5">
                    <div className="flex flex-col">
                        <div className="py-2 font-normal leading-7 text-eq-grey">
                            <a
                                className="gap-1 w-fit ease-linear transition-transform duration-300 flex cursor-pointer text-center items-center text-lg whitespace-nowrap"
                                onClick={handleLogOutPopup}
                            >
                                <span className="text-[0.875rem]">
                                    <span className="pb-[3px]">Log out</span>
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="flyout-button flex justify-start cursor-pointer py-2 w-auto whitespace-nowrap items-center transition-all ease-linear duration-300">
                <a className="text-sm leading-6 font-bold">{userText}</a>
                <div className="px-2">
                    <svg
                        stroke="currentColor"
                        fill="none"
                        stroke-width="0"
                        viewBox="0 0 24 24"
                        className="flyout-chevron transition-all ease-in-out duration-300 rotate-180"
                        height="1em"
                        width="1em"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                    </svg>
                </div>
            </div>
        </div>
    );
};
